// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetOpenapiV1Ping (params?: {}): Promise<Dict>;
    publicGetOpenapiV1Time (params?: {}): Promise<Dict>;
    publicGetOpenapiV1UserIp (params?: {}): Promise<Dict>;
    publicGetOpenapiQuoteV1Ticker24hr (params?: {}): Promise<Dict | List>;
    publicGetOpenapiQuoteV1TickerPrice (params?: {}): Promise<Dict>;
    publicGetOpenapiQuoteV1TickerBookTicker (params?: {}): Promise<List>;
    publicGetOpenapiV1ExchangeInfo (params?: {}): Promise<Dict>;
    publicGetOpenapiQuoteV1Depth (params?: {}): Promise<Dict>;
    publicGetOpenapiQuoteV1Klines (params?: {}): Promise<List>;
    publicGetOpenapiQuoteV1Trades (params?: {}): Promise<List>;
    publicGetOpenapiV1Pairs (params?: {}): Promise<List>;
    publicGetOpenapiQuoteV1AvgPrice (params?: {}): Promise<Dict>;
    privateGetOpenapiV1CheckSysStatus (params?: {}): Promise<List>;
    privateGetOpenapiWalletV1ConfigGetall (params?: {}): Promise<List>;
    privateGetOpenapiWalletV1DepositAddress (params?: {}): Promise<Dict>;
    privateGetOpenapiWalletV1DepositHistory (params?: {}): Promise<List>;
    privateGetOpenapiWalletV1WithdrawHistory (params?: {}): Promise<List>;
    privateGetOpenapiWalletV1WithdrawAddressWhitelist (params?: {}): Promise<List>;
    privateGetOpenapiV1Account (params?: {}): Promise<Dict>;
    privateGetOpenapiV1ApiKeys (params?: {}): Promise<List>;
    privateGetOpenapiV1OpenOrders (params?: {}): Promise<List>;
    privateGetOpenapiV1AssetTradeFee (params?: {}): Promise<List>;
    privateGetOpenapiV1Order (params?: {}): Promise<Dict>;
    privateGetOpenapiV1HistoryOrders (params?: {}): Promise<List>;
    privateGetOpenapiV1MyTrades (params?: {}): Promise<List>;
    privateGetOpenapiV1CapitalDepositHistory (params?: {}): Promise<List>;
    privateGetOpenapiV1CapitalWithdrawHistory (params?: {}): Promise<List>;
    privateGetOpenapiV3PaymentRequestGetPaymentRequest (params?: {}): Promise<Dict>;
    privateGetMerchantApiV1GetInvoices (params?: {}): Promise<Dict>;
    privateGetOpenapiAccountV3CryptoAccounts (params?: {}): Promise<Dict>;
    privateGetOpenapiTransferV3TransfersId (params?: {}): Promise<Dict>;
    privateGetOpenapiV1SubAccountList (params?: {}): Promise<Dict>;
    privateGetOpenapiV1SubAccountAsset (params?: {}): Promise<Dict>;
    privateGetOpenapiV1SubAccountTransferUniversalTransferHistory (params?: {}): Promise<Dict>;
    privateGetOpenapiV1SubAccountTransferSubHistory (params?: {}): Promise<List>;
    privateGetOpenapiV1SubAccountApikeyIpRestriction (params?: {}): Promise<Dict>;
    privateGetOpenapiV1SubAccountWalletDepositAddress (params?: {}): Promise<Dict>;
    privateGetOpenapiV1SubAccountWalletDepositHistory (params?: {}): Promise<Dict>;
    privateGetOpenapiV1FundCollectGetFundRecord (params?: {}): Promise<List>;
    privateGetOpenapiV1AssetTransactionHistory (params?: {}): Promise<Dict>;
    privatePostOpenapiWalletV1WithdrawApply (params?: {}): Promise<Dict>;
    privatePostOpenapiV1OrderTest (params?: {}): Promise<Dict>;
    privatePostOpenapiV1Order (params?: {}): Promise<Dict>;
    privatePostOpenapiV1OrderCancelReplace (params?: {}): Promise<Dict>;
    privatePostOpenapiV1CapitalWithdrawApply (params?: {}): Promise<Dict>;
    privatePostOpenapiV1CapitalDepositApply (params?: {}): Promise<Dict>;
    privatePostOpenapiV3PaymentRequestPaymentRequests (params?: {}): Promise<Dict>;
    privatePostOpenapiV3PaymentRequestDeletePaymentRequest (params?: {}): Promise<Dict>;
    privatePostOpenapiV3PaymentRequestPaymentRequestReminder (params?: {}): Promise<string>;
    privatePostOpenapiV1UserDataStream (params?: {}): Promise<Dict>;
    privatePostMerchantApiV1Invoices (params?: {}): Promise<Dict>;
    privatePostMerchantApiV1InvoicesCancel (params?: {}): Promise<Dict>;
    privatePostOpenapiConvertV1GetSupportedTradingPairs (params?: {}): Promise<Dict>;
    privatePostOpenapiConvertV1GetQuote (params?: {}): Promise<Dict>;
    privatePostOpenapiConvertV1AcceptQuote (params?: {}): Promise<Dict>;
    privatePostOpenapiConvertV1QueryOrderHistory (params?: {}): Promise<Dict>;
    privatePostOpenapiOtcTradeV1GetSupportedTradingPairs (params?: {}): Promise<Dict>;
    privatePostOpenapiOtcTradeV1CreateRfq (params?: {}): Promise<Dict>;
    privatePostOpenapiOtcTradeV1AcceptRfq (params?: {}): Promise<Dict>;
    privatePostOpenapiOtcTradeV1ManualSettle (params?: {}): Promise<Dict>;
    privatePostOpenapiOtcTradeV1QueryOrderHistory (params?: {}): Promise<Dict>;
    privatePostOpenapiFiatV1SupportChannel (params?: {}): Promise<Dict>;
    privatePostOpenapiFiatV1CashOut (params?: {}): Promise<Dict>;
    privatePostOpenapiFiatV1History (params?: {}): Promise<Dict>;
    privatePostOpenapiFiatV2History (params?: {}): Promise<Dict>;
    privatePostOpenapiFiatV1CancelQrCode (params?: {}): Promise<Dict>;
    privatePostOpenapiMigrationV4Sellorder (params?: {}): Promise<Dict>;
    privatePostOpenapiMigrationV4ValidateField (params?: {}): Promise<Dict>;
    privatePostOpenapiTransferV3Transfers (params?: {}): Promise<Dict>;
    privatePostOpenapiTransferV4Transfers (params?: {}): Promise<Dict>;
    privatePostOpenapiV1SubAccountCreate (params?: {}): Promise<Dict>;
    privatePostOpenapiV1SubAccountTransferUniversalTransfer (params?: {}): Promise<Dict>;
    privatePostOpenapiV1SubAccountTransferSubToMaster (params?: {}): Promise<Dict>;
    privatePostOpenapiV1SubAccountApikeyAddIpRestriction (params?: {}): Promise<Dict>;
    privatePostOpenapiV1SubAccountApikeyDeleteIpRestriction (params?: {}): Promise<Dict>;
    privatePostOpenapiV1FundCollectCollectFromSubAccount (params?: {}): Promise<Dict>;
    privatePutOpenapiV1UserDataStream (params?: {}): Promise<Dict>;
    privateDeleteOpenapiV1Order (params?: {}): Promise<Dict>;
    privateDeleteOpenapiV1OpenOrders (params?: {}): Promise<List>;
    privateDeleteOpenapiV1UserDataStream (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
